<mat-card class="padding all margin all">
    <mat-card-header class="header-container">
      <mat-card-title>Add Attachments</mat-card-title>
        <div class="row flex-end center">
              <button *ngIf="expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
                <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
              </button>
              <button *ngIf="!expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
                <mat-icon fontSet="material-icons-outlined">expand_less</mat-icon>
              </button>
        </div>
    </mat-card-header>
    <mat-card-content *ngIf="expanded" class="padding lrg all">
        <div class="row full-width">
                  <input type="file" #file id="file-upload" accept=".pdf, .xlsx, .xls" (change)="uploadAttachment($event.target.files)">
                  <button class="margin all" mat-stroked-button (click)="file.click()"><mat-icon class="padding right">attachment</mat-icon> Upload Attachment</button>
                <p class="margin all padding all noAttachments" *ngIf="!hasAttachments">No attachments added</p>
        </div>
        
        <table *ngIf="hasAttachments" mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef>Last Modified</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.createdOn | date: 'M/d/yy h:mma' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="createdOn-filter">
            <th mat-header-cell *matHeaderCellDef>
              <div class="padding right margin right">
                <input matInput placeholder="Search Last Modified" class="columnSearch" (keyup)="applyFilter($event)" />
              </div>
            </th>
          </ng-container>
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef>Created By</th>
            <td mat-cell *matCellDef="let element">{{ element?.createdBy }}</td>
          </ng-container>
          <ng-container matColumnDef="createdBy-filter">
            <th mat-header-cell *matHeaderCellDef>
              <div class="padding right margin right">
                <input matInput placeholder="Search Created By" class="columnSearch" (keyup)="applyFilter($event)" />
              </div>
            </th>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">{{ element?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="name-filter">
            <th mat-header-cell *matHeaderCellDef>
              <div class="padding right margin right">
                <input matInput placeholder="Search File Name" class="columnSearch" (keyup)="applyFilter($event)" />
              </div>
            </th>
          </ng-container>
          <ng-container matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="downloadAttachment(element)">
                <mat-icon>download</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="download-filter">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button [disabled]="isDeleteDisabled(element)" (click)="deleteAttachment(element)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="delete-filter">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-header-row *matHeaderRowDef="displayedColumnFilters"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
        class="paginator-wrapper"
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [pageIndex]="currentPage"
        (page)="pageChanged($event)"
        showFirstLastButtons
        aria-label="attachments"
      >
      </mat-paginator>
    </mat-card-content>
</mat-card>